import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'date-time-format-timezone';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import {TokenProvider} from '_services';
import {theme} from '_styles'
import {store} from '_redux';
import * as serviceWorker from './serviceWorker';
import App from './App';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <TokenProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </TokenProvider>
  </Provider>
);

serviceWorker.unregister();
